<div class="policy-configuration-tool">
  <section class="tool-header">
    <div>
      <h3>Configure Policies for New TestObjects</h3>
      <p>{{ rows.length }} new TestObject{{ rows.length === 1 ? '' : 's' }}</p>
    </div>
  </section>

  @if (hasNewTestObjects) {
    @if (rows.length > 1) {
      <section class="bulk-section">
        <div class="bulk-header">
          <div>
            <h4>Apply to all new</h4>
          </div>
          <div class="bulk-actions">
            <button pButton type="button" class="p-button-outlined p-button-sm"
                    label="Apply to all"
                    [disabled]="hasMixedPolicyTargets || !hasPolicy(bulkPolicy) || saving"
                    (click)="applyBulkPolicy()"></button>
            <button pButton type="button" class="p-button-outlined p-button-sm p-button-secondary"
                    label="Clear all"
                    [disabled]="hasMixedPolicyTargets || saving"
                    (click)="clearAll()"></button>
          </div>
        </div>
        @if (hasMixedPolicyTargets) {
          <div class="policy-warning">
            Bulk editing is unavailable when the selection contains both web and mobile Test Objects.
          </div>
        } @else {
          <wm-automation-policy-editor [mode]="bulkPolicyMode" [(ngModel)]="bulkPolicy"></wm-automation-policy-editor>
        }
      </section>
    }

    <section class="policy-list">
      @for (row of rows; track trackRow($index, row)) {
        <article class="policy-row" [class.is-expanded]="row.expanded">
          <div class="row-summary">
            <button type="button" class="row-toggle" (click)="toggleRow(row)">
              <span class="row-title">{{ getDisplayName(row.testObject) }}</span>
              <span class="row-subtitle">{{ getDisplaySecondary(row.testObject) }}</span>
            </button>
            <div class="row-actions">
              @if (isRowChanged(row)) {
                <span class="row-state is-changed">Changed</span>
              } @else if (hasPolicy(row.policyDraft)) {
                <span class="row-state">Policy configured</span>
              } @else {
                <span class="row-state is-empty">No policy</span>
              }
              <button pButton type="button" class="p-button-outlined p-button-sm p-button-secondary"
                      label="Clear"
                      [disabled]="saving || !hasPolicy(row.policyDraft)"
                      (click)="clearRow(row)"></button>
            </div>
          </div>

          @if (row.expanded) {
            <div class="row-editor">
              @if (isManualOnly(row) && hasPolicy(row.policyDraft)) {
                <div class="policy-warning">
                  Matching-default applicability cannot scope automation for manual-only TestObjects.
                </div>
              }
              <wm-automation-policy-editor [mode]="isMobileTestObject(row.testObject) ? 'mobile' : 'web'"
                                           [(ngModel)]="row.policyDraft"></wm-automation-policy-editor>
              @if (row.saving) {
                <div class="row-saving">
                  <p-progressSpinner strokeWidth="4"></p-progressSpinner>
                  <span>Saving policy...</span>
                </div>
              }
              @if (row.error) {
                <div class="row-error">{{ row.error }}</div>
              }
            </div>
          }
        </article>
      }
    </section>
  } @else {
    <section class="empty-section">
      <div class="empty-title">No new TestObjects</div>
      <div class="empty-copy">Resolved TestObjects already existed in the project.</div>
    </section>
  }

  @if (config.existingTestObjects.length > 0) {
    <section class="existing-section">
      <h4>Existing TestObjects</h4>
      <div class="existing-list">
        @for (testObject of config.existingTestObjects; track trackTestObject($index, testObject)) {
          <div class="existing-row">
            <span>{{ getDisplayName(testObject) }}</span>
            <small>{{ getDisplaySecondary(testObject) }}</small>
          </div>
        }
      </div>
    </section>
  }

  <div class="actions">
    <button pButton type="button" class="p-button-outlined p-button-secondary"
            label="Skip"
            [disabled]="saving"
            (click)="skip()"></button>
    <button pButton type="button"
            [label]="changedRows.length > 0 ? 'Save and Finish' : 'Finish'"
            [loading]="saving"
            [disabled]="saving"
            (click)="save()"></button>
  </div>
</div>
